<template>
  <div>
    <div class="main-content">
      <!-- title -->
      <div class="layout-all">
        <div class="title-content">
          <div class="d-flex justify-center">
            {{ FiltersLanguage(item_debenture_information_page, "title") }}
            <div>
              <v-img
                class="title-icon"
                :src="require(`@/${item_debenture_information_page.img_dot}`)"
              ></v-img>
            </div>
          </div>
        </div>
        <hr class="hr-border" />
        <!-- table_top_10_shareholders -->
        <div class="table-style">
          <tableComponent
            :headers="modifiedHeaders(headerTableDebentureInformation)"
            :items="itemsTableDebentureInformations"
            ColorTextHeader="#000000"
            :loading="loadingTableDebentureInformation"
            bgHeader="#F6F6F6"
            bgTable="#FFFFFF"
            class="custom-bg-row"
          >
            <template v-slot:[`item.no`]="{ item }">
              <div class="">
                {{ FiltersLanguage(item, "no") }}
              </div>
            </template>
            <template v-slot:[`item.issue_amount`]="{ item }">
              <div>
                {{ returncommaNumberDecimal(parseFloat(item.issue_amount)) }}
              </div>
            </template>
            <template v-slot:[`item.coupon_rate`]="{ item }">
              <div>
                {{ returncommaNumber(parseFloat(item.coupon_rate)) }}%
              </div>
            </template>
            <template v-slot:[`item.issue_date`]="{ item }">
              <div v-if="$store.state.language === 'eng'" class="pa-0">
                {{returnDateFull(item.issue_date_eng,'eng','D MMMM yyyy')}}
              </div>
              <div v-if="$store.state.language === 'th'" class="pa-0">
                {{returnDateFull(item.issue_date_eng,'th','D MMMM yyyy')}}
              </div>
            </template>
            <template v-slot:[`item.maturity_date`]="{ item }">
              <div v-if="$store.state.language === 'eng'" class="pa-0">
                {{returnDateFull(item.maturity_date_eng,'eng','D MMMM yyyy')}}
              </div>
              <div v-if="$store.state.language === 'th'" class="pa-0">
                {{returnDateFull(item.maturity_date_eng,'th','D MMMM yyyy')}}
              </div>
            </template>
            <template v-slot:[`item.tenors`]="{ item }">
              <div>
                {{ FiltersLanguage(item, "tenors") }}
              </div>
            </template>
            <template v-slot:[`item.filling`]="{ item }">
              <div>
                <a
                  :href="`${FiltersLanguage(item, 'filling')}`"
                  target="_blank"
                ><v-icon class="icon-search">mdi-magnify
                </v-icon></a>
              </div>
            </template>
          </tableComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableComponent from '../../../components/table.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    tableComponent
  },
  data () {
    return {
      headerTableDebentureInformation: [],
      loadingTableDebentureInformation: false,
      itemsTableDebentureInformationAll: [],
      itemsTableDebentureInformations: [],
      paginationTableDebentureInformation: {
        total: 0,
        page: 1,
        row: 9999
      }
    }
  },
  created () {
    this.initTableDebentureInformation()
  },
  // mounted () {
  //   const element = document.getElementById('top-page')
  //   element.scrollIntoView(true)
  // },
  computed: {
    ...mapGetters(['item_debenture_information_page', 'language'])
  },
  methods: {
    modifiedHeaders (itemHeader) {
      return itemHeader.map((header) => ({
        ...header,
        text: header[`text_${this.language}`] // Change the text to text_th
      }))
    },
    async initTableDebentureInformation () {
      this.loadingTableDebentureInformation = true
      const payload = {
        page: this.paginationTableDebentureInformation.page,
        row: this.paginationTableDebentureInformation.row,
        keyword: 'Debenture Information'
      }
      this.itemsTableDebentureInformationAll = []
      const res = await this.getItemsTable(payload)
      this.loadingTableDebentureInformation = false
      if (res.status) {
        this.itemsTableDebentureInformationAll = res.data.data[0]
        this.headerTableDebentureInformation = res.data.data[0].headers

        for (let index = 0; index < res.data.data[0].datas.length; index++) {
          if (this.$moment().startOf('day') <= this.$moment(res.data.data[0].datas[index].maturity_date_eng).startOf('day')) {
            this.itemsTableDebentureInformations.push(res.data.data[0].datas[index])
          }
        }

        // this.itemsTableDebentureInformations = res.data.data[0].datas
        this.paginationTableDebentureInformation.total = this.itemsTableDebentureInformations.length
        this.paginationTableDebentureInformation.page =
          res.data.pagination.page
      } else {
        this.antmessage.error(res.message)
      }
    }
  }
}
</script>

<style scoped>

>>> .theme--light.v-data-table.v-data-table--fixed-header thead th {
  background-color: unset !important;
  padding-top: 20px;
  padding-bottom: 20px;
}

>>> .custom-bg-row
  .v-data-table
  .v-data-table__wrapper
  table
  .v-data-table-header
  tr {
  background: linear-gradient(
    90.16deg,
    var(--v-hoverListItem3-base) 44.53%,
    var(--v-hoverListItem4-base) 100%
  );
}
>>> .custom-bg-row .v-data-table .v-data-table__wrapper table tbody tr td div {
  padding-top: 15px;
  padding-bottom: 12px;
  padding-left: 12px;
  padding-right: 12px;
  width: 100%;
}

.layout-all {
  margin-right: 20px;
  margin-left: 20px;
}
.title-content {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  padding-top: 4rem;
  text-align: center;
  margin-bottom: 20px;
}
.title-icon {
  width: 16px;
  height: 16px;
  margin-left: 5px;
}
.hr-border {
  color: var(--v-linerPrimary-base) !important;
  margin-top: 40px;
  margin-bottom: 40px;
}
.table-style {
  margin-bottom: 80px;
}
.text-table {
  font-size: 16px;
}

.icon-search{
color: var(--v-loadingTable-base) !important;
padding: 5px;
border-radius: 20px;
}
.icon-search:hover {
  padding: 5px;
  color: var(--v-textMenu-base) !important;
  cursor: pointer;
  border-radius: 20px;
  background-color: var(--v-loadingTable-base) !important;
}
@media screen and (max-width: 984px) {
  .hr-border {
    color: var(--v-linerPrimary-base) !important;
    margin-top: 20px;
    margin-bottom: 30px;
  }
}
</style>
